/**
 * Returns the Project Row Data Table Row component.
 * 
 * @param { ARF AWS Project Object Data } project
 * @param { Select Change Handler for the selected project } fileApproval
 * @returns The Project Row Data Table Row component.
 */
const ProjectRowData = ({ project, fileApproval, setShow }) => {
    const handleClick = () => {
        setShow(false);
        fileApproval(project);
    };

    return (
        <>
            <tr key={project.id} className="py-12">
                <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
                    {project.name}

                    <dl className="font-normal lg:hidden">
                        <dt className="sr-only">Owner</dt>
                        <dd className="mt-1 truncate text-gray-700">{project.owner}</dd>
                        <dt className="sr-only sm:hidden">Email</dt>
                        <dd className="mt-1 truncate text-gray-500 sm:hidden">{project.email}</dd>
                    </dl>
                </td>
                
                <td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">{project.owner}</td>
                <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">{project.email}</td>
                <td className="px-3 py-4 text-sm text-gray-500">{project.date}</td>

                <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <button
                        onClick={handleClick}
                        className="inline-flex items-center text-sm px-4 py-2 sm:text-base sm:px-2.5 sm:py-1 border border-transparent leading-4 font-medium rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Action
                        <span className="sr-only">, {project.Date}</span>
                    </button>
                </td>
            </tr>
        </>
    );
};

export default ProjectRowData;